import { UserRoleEnum } from '@constants/enums/UserRole.enum';
import { AuthTokenFragment } from '@gql/types';

import { parseJwt } from './parsers/parseJwt';

export const getUserAuthToken = (): string => {
  const localStorageToken = localStorage.getItem('token');

  if (localStorageToken) {
    try {
      const parsedToken = JSON.parse(localStorageToken);

      if (parsedToken.token) {
        return parsedToken.token;
      }
    } catch {
      localStorage.removeItem('token');

      return '';
    }
  }

  return '';
};

export const getUserToken = (): AuthTokenFragment | null => {
  const localStorageToken = localStorage.getItem('token');

  if (localStorageToken) {
    try {
      const parsedToken = JSON.parse(localStorageToken);

      if (parsedToken.token) {
        return parsedToken;
      }
    } catch {
      localStorage.removeItem('token');
    }
  }

  return null;
};

export const getUserRefreshToken = (): string => {
  const localStorageToken = localStorage.getItem('token');

  if (localStorageToken) {
    try {
      const parsedToken = JSON.parse(localStorageToken);

      if (parsedToken.refreshToken) {
        return parsedToken.refreshToken;
      }
    } catch {
      localStorage.removeItem('token');

      return '';
    }
  }

  return '';
};

export const setUserToken = (token: AuthTokenFragment): void => {
  localStorage.setItem('token', JSON.stringify(token));
};

export const removeUserToken = (): void => {
  localStorage.removeItem('token');
};

export const getUserRoles = (): string[] => {
  const token = getUserAuthToken();

  if (token) {
    return parseJwt(token).roles;
  }

  return [];
};

export const isAdminUser = (): boolean => {
  const roles = getUserRoles();

  return (
    roles.includes(UserRoleEnum.SYSTEM_ADMIN) ||
    roles.includes(UserRoleEnum.SYSTEM_SELLER)
  );
};

export const isSystemAdmin = (): boolean =>
  getUserRoles().includes(UserRoleEnum.SYSTEM_ADMIN);

export const getUserIdFromToken = (): string => {
  const token = getUserAuthToken();

  // username is id
  if (token) return parseJwt(token).username ?? '';

  return '';
};
